/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type FindAllDashboards200Response,
    FindAllDashboards200ResponseFromJSON,
    FindAllDashboards200ResponseToJSON,
} from '../models/FindAllDashboards200Response';
import {
    type FindDataCenterNavigation200Response,
    FindDataCenterNavigation200ResponseFromJSON,
    FindDataCenterNavigation200ResponseToJSON,
} from '../models/FindDataCenterNavigation200Response';
import {
    type OmniGenerateDashboardIFrameUrlRequest,
    OmniGenerateDashboardIFrameUrlRequestFromJSON,
    OmniGenerateDashboardIFrameUrlRequestToJSON,
} from '../models/OmniGenerateDashboardIFrameUrlRequest';
import {
    type OmniGenerateHomeIFrameUrlRequest,
    OmniGenerateHomeIFrameUrlRequestFromJSON,
    OmniGenerateHomeIFrameUrlRequestToJSON,
} from '../models/OmniGenerateHomeIFrameUrlRequest';
import {
    type OmniGenerateIFrameUrl201Response,
    OmniGenerateIFrameUrl201ResponseFromJSON,
    OmniGenerateIFrameUrl201ResponseToJSON,
} from '../models/OmniGenerateIFrameUrl201Response';
import {
    type OmniGenerateIFrameUrlForReportBuilderRequest,
    OmniGenerateIFrameUrlForReportBuilderRequestFromJSON,
    OmniGenerateIFrameUrlForReportBuilderRequestToJSON,
} from '../models/OmniGenerateIFrameUrlForReportBuilderRequest';
import {
    type OmniGenerateIFrameUrlRequest,
    OmniGenerateIFrameUrlRequestFromJSON,
    OmniGenerateIFrameUrlRequestToJSON,
} from '../models/OmniGenerateIFrameUrlRequest';

export interface FindDataCenterNavigationRequest {
    /**
     * 
     */
    facilityType: FindDataCenterNavigationFacilityTypeEnum;
}

export interface OmniGenerateAskAiIFrameUrlRequest {
    /**
     * 
     */
    omniGenerateIFrameUrlForReportBuilderRequest: OmniGenerateIFrameUrlForReportBuilderRequest;
}

export interface OmniGenerateDashboardIFrameUrlOperationRequest {
    /**
     * 
     */
    omniGenerateDashboardIFrameUrlRequest: OmniGenerateDashboardIFrameUrlRequest;
}

export interface OmniGenerateHomeIFrameUrlOperationRequest {
    /**
     * 
     */
    omniGenerateHomeIFrameUrlRequest: OmniGenerateHomeIFrameUrlRequest;
}

export interface OmniGenerateIFrameUrlOperationRequest {
    /**
     * 
     */
    omniGenerateIFrameUrlRequest: OmniGenerateIFrameUrlRequest;
}

export interface OmniGenerateIFrameUrlForReportBuilderOperationRequest {
    /**
     * 
     */
    omniGenerateIFrameUrlForReportBuilderRequest: OmniGenerateIFrameUrlForReportBuilderRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for findAllDashboards without sending the request
     */
    async findAllDashboardsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/dashboards`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get dashboards
     */
    async findAllDashboardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllDashboards200Response>> {
        const requestOptions = await this.findAllDashboardsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllDashboards200ResponseFromJSON(jsonValue));
    }

    /**
     * Get dashboards
     */
    async findAllDashboards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllDashboards200Response> {
        const response = await this.findAllDashboardsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findDataCenterNavigation without sending the request
     */
    async findDataCenterNavigationRequestOpts(requestParameters: FindDataCenterNavigationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['facilityType'] == null) {
            throw new runtime.RequiredError(
                'facilityType',
                'Required parameter "facilityType" was null or undefined when calling findDataCenterNavigation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['facilityType'] != null) {
            queryParameters['facility_type'] = requestParameters['facilityType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v3/navigation`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Resolve the Data Center 3.0 navigation for a care setting
     */
    async findDataCenterNavigationRaw(requestParameters: FindDataCenterNavigationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindDataCenterNavigation200Response>> {
        const requestOptions = await this.findDataCenterNavigationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindDataCenterNavigation200ResponseFromJSON(jsonValue));
    }

    /**
     * Resolve the Data Center 3.0 navigation for a care setting
     */
    async findDataCenterNavigation(requestParameters: FindDataCenterNavigationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindDataCenterNavigation200Response> {
        const response = await this.findDataCenterNavigationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for omniGenerateAskAiIFrameUrl without sending the request
     */
    async omniGenerateAskAiIFrameUrlRequestOpts(requestParameters: OmniGenerateAskAiIFrameUrlRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['omniGenerateIFrameUrlForReportBuilderRequest'] == null) {
            throw new runtime.RequiredError(
                'omniGenerateIFrameUrlForReportBuilderRequest',
                'Required parameter "omniGenerateIFrameUrlForReportBuilderRequest" was null or undefined when calling omniGenerateAskAiIFrameUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v3/omni/iframe-url/ask-ai`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OmniGenerateIFrameUrlForReportBuilderRequestToJSON(requestParameters['omniGenerateIFrameUrlForReportBuilderRequest']),
        };
    }

    /**
     * Generate an Omni iframe URL for the standalone Ask AI chat
     */
    async omniGenerateAskAiIFrameUrlRaw(requestParameters: OmniGenerateAskAiIFrameUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OmniGenerateIFrameUrl201Response>> {
        const requestOptions = await this.omniGenerateAskAiIFrameUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OmniGenerateIFrameUrl201ResponseFromJSON(jsonValue));
    }

    /**
     * Generate an Omni iframe URL for the standalone Ask AI chat
     */
    async omniGenerateAskAiIFrameUrl(requestParameters: OmniGenerateAskAiIFrameUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OmniGenerateIFrameUrl201Response> {
        const response = await this.omniGenerateAskAiIFrameUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for omniGenerateDashboardIFrameUrl without sending the request
     */
    async omniGenerateDashboardIFrameUrlRequestOpts(requestParameters: OmniGenerateDashboardIFrameUrlOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['omniGenerateDashboardIFrameUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'omniGenerateDashboardIFrameUrlRequest',
                'Required parameter "omniGenerateDashboardIFrameUrlRequest" was null or undefined when calling omniGenerateDashboardIFrameUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v3/omni/iframe-url/dashboard`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OmniGenerateDashboardIFrameUrlRequestToJSON(requestParameters['omniGenerateDashboardIFrameUrlRequest']),
        };
    }

    /**
     * Generate an Omni iframe URL for a Data Center 3.0 dashboard
     */
    async omniGenerateDashboardIFrameUrlRaw(requestParameters: OmniGenerateDashboardIFrameUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OmniGenerateIFrameUrl201Response>> {
        const requestOptions = await this.omniGenerateDashboardIFrameUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OmniGenerateIFrameUrl201ResponseFromJSON(jsonValue));
    }

    /**
     * Generate an Omni iframe URL for a Data Center 3.0 dashboard
     */
    async omniGenerateDashboardIFrameUrl(requestParameters: OmniGenerateDashboardIFrameUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OmniGenerateIFrameUrl201Response> {
        const response = await this.omniGenerateDashboardIFrameUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for omniGenerateHomeIFrameUrl without sending the request
     */
    async omniGenerateHomeIFrameUrlRequestOpts(requestParameters: OmniGenerateHomeIFrameUrlOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['omniGenerateHomeIFrameUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'omniGenerateHomeIFrameUrlRequest',
                'Required parameter "omniGenerateHomeIFrameUrlRequest" was null or undefined when calling omniGenerateHomeIFrameUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v3/omni/iframe-url/home`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OmniGenerateHomeIFrameUrlRequestToJSON(requestParameters['omniGenerateHomeIFrameUrlRequest']),
        };
    }

    /**
     * Generate an Omni iframe URL for the care setting\'s home dashboard
     */
    async omniGenerateHomeIFrameUrlRaw(requestParameters: OmniGenerateHomeIFrameUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OmniGenerateIFrameUrl201Response>> {
        const requestOptions = await this.omniGenerateHomeIFrameUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OmniGenerateIFrameUrl201ResponseFromJSON(jsonValue));
    }

    /**
     * Generate an Omni iframe URL for the care setting\'s home dashboard
     */
    async omniGenerateHomeIFrameUrl(requestParameters: OmniGenerateHomeIFrameUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OmniGenerateIFrameUrl201Response> {
        const response = await this.omniGenerateHomeIFrameUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for omniGenerateIFrameUrl without sending the request
     */
    async omniGenerateIFrameUrlRequestOpts(requestParameters: OmniGenerateIFrameUrlOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['omniGenerateIFrameUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'omniGenerateIFrameUrlRequest',
                'Required parameter "omniGenerateIFrameUrlRequest" was null or undefined when calling omniGenerateIFrameUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/omni/iframe-url`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OmniGenerateIFrameUrlRequestToJSON(requestParameters['omniGenerateIFrameUrlRequest']),
        };
    }

    /**
     * Generate an Omni iframe URL
     */
    async omniGenerateIFrameUrlRaw(requestParameters: OmniGenerateIFrameUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OmniGenerateIFrameUrl201Response>> {
        const requestOptions = await this.omniGenerateIFrameUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OmniGenerateIFrameUrl201ResponseFromJSON(jsonValue));
    }

    /**
     * Generate an Omni iframe URL
     */
    async omniGenerateIFrameUrl(requestParameters: OmniGenerateIFrameUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OmniGenerateIFrameUrl201Response> {
        const response = await this.omniGenerateIFrameUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for omniGenerateIFrameUrlForReportBuilder without sending the request
     */
    async omniGenerateIFrameUrlForReportBuilderRequestOpts(requestParameters: OmniGenerateIFrameUrlForReportBuilderOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['omniGenerateIFrameUrlForReportBuilderRequest'] == null) {
            throw new runtime.RequiredError(
                'omniGenerateIFrameUrlForReportBuilderRequest',
                'Required parameter "omniGenerateIFrameUrlForReportBuilderRequest" was null or undefined when calling omniGenerateIFrameUrlForReportBuilder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/omni/iframe-url/report-builder`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OmniGenerateIFrameUrlForReportBuilderRequestToJSON(requestParameters['omniGenerateIFrameUrlForReportBuilderRequest']),
        };
    }

    /**
     * Generate an Omni iframe URL for report builder
     */
    async omniGenerateIFrameUrlForReportBuilderRaw(requestParameters: OmniGenerateIFrameUrlForReportBuilderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OmniGenerateIFrameUrl201Response>> {
        const requestOptions = await this.omniGenerateIFrameUrlForReportBuilderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OmniGenerateIFrameUrl201ResponseFromJSON(jsonValue));
    }

    /**
     * Generate an Omni iframe URL for report builder
     */
    async omniGenerateIFrameUrlForReportBuilder(requestParameters: OmniGenerateIFrameUrlForReportBuilderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OmniGenerateIFrameUrl201Response> {
        const response = await this.omniGenerateIFrameUrlForReportBuilderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FindDataCenterNavigationFacilityTypeEnum = {
    SkilledNursing: 'SKILLED_NURSING',
    CriticalCare: 'CRITICAL_CARE',
    HomeHealth: 'HOME_HEALTH',
    AssistedLiving: 'ASSISTED_LIVING',
    LongTermCareHospital: 'LONG_TERM_CARE_HOSPITAL',
    Hospice: 'HOSPICE',
    DialysisCenter: 'DIALYSIS_CENTER',
    Hospital: 'HOSPITAL',
} as const;
export type FindDataCenterNavigationFacilityTypeEnum = typeof FindDataCenterNavigationFacilityTypeEnum[keyof typeof FindDataCenterNavigationFacilityTypeEnum];
